import { Calendar, Clock, Check, MessageSquare, Bell, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export const DashboardTab = ({
  stats,
  bookings,
  userRole,
  remindersStatus,
  sendingReminders,
  onSendReminders,
}) => {
  if (!stats) return null;

  const statCards = [
    { label: 'Reservas Totales', value: stats.total_bookings, icon: Calendar },
    { label: 'Pendientes', value: stats.pending_bookings, icon: Clock },
    { label: 'Confirmadas', value: stats.confirmed_bookings, icon: Check },
    { label: 'Mensajes', value: stats.total_contacts, icon: MessageSquare },
  ];

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((stat) => (
          <div key={stat.label} className="bg-halo-surface rounded-xl p-4 lg:p-6 border border-halo-taupe/10">
            <div className="flex items-center gap-3 mb-2">
              <stat.icon size={20} className="text-halo-brown" />
              <span className="text-halo-text text-xs lg:text-sm">{stat.label}</span>
            </div>
            <p className="font-heading text-2xl lg:text-3xl text-halo-charcoal">{stat.value}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-halo-surface rounded-xl p-6 border border-halo-taupe/10">
          <h3 className="font-heading text-xl text-halo-charcoal mb-4">Ingresos</h3>
          <div className="space-y-4">
            <div>
              <p className="text-halo-text text-sm">Total Facturado</p>
              <p className="font-heading text-3xl text-halo-brown">{stats.revenue?.toFixed(2) || 0}€</p>
            </div>
            <div>
              <p className="text-halo-text text-sm">Depósitos Cobrados</p>
              <p className="font-heading text-2xl text-halo-charcoal">{stats.deposits_collected?.toFixed(2) || 0}€</p>
            </div>
          </div>
        </div>

        <div className="bg-halo-surface rounded-xl p-6 border border-halo-taupe/10">
          <h3 className="font-heading text-xl text-halo-charcoal mb-4">Últimas Reservas</h3>
          <div className="space-y-3">
            {bookings.slice(0, 5).map((booking) => (
              <div key={booking.id} className="flex items-center justify-between text-sm">
                <span className="text-halo-charcoal">{booking.customer_name}</span>
                <span className={`px-2 py-1 rounded-full text-xs ${
                  booking.status === 'confirmed' ? 'bg-green-100 text-green-700' :
                  booking.status === 'pending' ? 'bg-yellow-100 text-yellow-700' :
                  'bg-gray-100 text-gray-700'
                }`}>
                  {booking.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {(userRole === 'admin' || userRole === 'office') && (
        <div className="bg-halo-surface rounded-xl p-6 border border-halo-taupe/10">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <Bell size={24} className="text-halo-brown" />
              <h3 className="font-heading text-xl text-halo-charcoal">Recordatorios de Citas</h3>
            </div>
            <Button
              onClick={onSendReminders}
              disabled={sendingReminders || !remindersStatus?.pending_reminders}
              className="bg-halo-brown hover:bg-halo-charcoal"
              data-testid="send-reminders-btn"
            >
              {sendingReminders ? (
                <RefreshCw size={16} className="animate-spin mr-2" />
              ) : (
                <Bell size={16} className="mr-2" />
              )}
              Enviar Recordatorios
            </Button>
          </div>

          {remindersStatus ? (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-halo-cream rounded-lg p-4">
                <p className="text-halo-text text-xs mb-1">Fecha mañana</p>
                <p className="font-heading text-lg text-halo-charcoal">{remindersStatus.tomorrow_date}</p>
              </div>
              <div className="bg-halo-cream rounded-lg p-4">
                <p className="text-halo-text text-xs mb-1">Reservas mañana</p>
                <p className="font-heading text-lg text-halo-charcoal">{remindersStatus.total_tomorrow_bookings}</p>
              </div>
              <div className="bg-halo-cream rounded-lg p-4">
                <p className="text-halo-text text-xs mb-1">Ya recordados</p>
                <p className="font-heading text-lg text-green-600">{remindersStatus.reminders_already_sent}</p>
              </div>
              <div className="bg-halo-cream rounded-lg p-4">
                <p className="text-halo-text text-xs mb-1">Pendientes</p>
                <p className="font-heading text-lg text-halo-brown">{remindersStatus.pending_reminders}</p>
              </div>
            </div>
          ) : (
            <p className="text-halo-text text-sm">Cargando estado de recordatorios...</p>
          )}

          {remindersStatus?.pending_list?.length > 0 && (
            <div className="mt-4 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
              <p className="text-sm font-medium text-yellow-800 mb-2">Clientes pendientes de recordatorio:</p>
              <ul className="text-sm text-yellow-700 space-y-1">
                {remindersStatus.pending_list.map((item) => (
                  <li key={`${item.customer_name}-${item.time}`}>• {item.customer_name} - {item.time} - {item.service}</li>
                ))}
              </ul>
            </div>
          )}

          <p className="text-xs text-halo-text mt-4">
            💡 Los recordatorios se envían por email 24h antes de la cita. Recibirás una copia en info@halocuevas.com
          </p>
        </div>
      )}
    </div>
  );
};
